// @flow
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import DefaultTheme from './theme';
import InfoBubble from '../info-bubble';
export var RadioButtonTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { InfoBubbleThemeType } from '../info-bubble';

export type RadioButtonThemeType = {
  Container: * => Node,
  Label: * => Node,
  Button: * => Node,
  InfoBubbleTheme: InfoBubbleThemeType,
}

type Props = {|
  checked: boolean;
  id: string;
  groupName: string;
  label: string;
  onClick: () => void;
  helpText?: string;
  theme?: RadioButtonThemeType;
|}
*/

var Input = styled.input.withConfig({
  displayName: "radio-button__Input",
  componentId: "sc-197n6h5-0"
})(["display:none;"]);

var RadioButton = function RadioButton(_ref
/*: Props */
) {
  var checked = _ref.checked,
      id = _ref.id,
      groupName = _ref.groupName,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$helpText = _ref.helpText,
      helpText = _ref$helpText === void 0 ? null : _ref$helpText,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;

  var _useState = useState(false),
      clicked = _useState[0],
      setClicked = _useState[1];

  var labelRef = useRef();

  var handleClickOutside = function handleClickOutside(e
  /*: any */
  ) {
    if (labelRef && labelRef.current && labelRef.current.contains(e.target)) {
      // inside click:
      setClicked(true);
      return;
    } // outside click:


    setClicked(false);
  };

  useEffect(function () {
    // register click outside handler
    document.addEventListener('mousedown', handleClickOutside, true); // remove event handlers from the document once component unmounts

    return function () {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/React.createElement(theme.Container, null, /*#__PURE__*/React.createElement(Input, {
    name: groupName,
    type: "radio",
    id: id,
    "data-test": "radio-button-input"
  }), /*#__PURE__*/React.createElement(theme.Label, {
    onClick: onClick,
    ref: labelRef,
    htmlFor: id,
    "data-test": "radio-button-label"
  }, /*#__PURE__*/React.createElement(theme.Button, {
    checked: checked,
    clicked: clicked,
    "data-test": "radio-button-span"
  }), label), helpText ? /*#__PURE__*/React.createElement(InfoBubble, {
    theme: theme.InfoBubbleTheme
  }, helpText) : null);
};

RadioButton.displayName = 'RadioButton';
export default RadioButton;